<template>
	<div class="smainheadern col-11">
		<div class="d-flex align-items-start justify-content-start col-12">
			<div class="stextarea col-12">
				<div class="shtextholder">
					<div class="stitle">{{ $t('submainheader.subtitle', 'Industries We Specialize In') }}</div>
					<div class="shtext">
						{{ $t('submainheader.title', 'We provide expert global recruitment solutions across the most in-demand tech industries, matching top talent with companies worldwide.') }}
					</div>
				</div>
				<div class="hscontent">
					<div class="d-flex align-items-start w-100">
						<div class="ms-auto">
							<div class="d-flex justify-content-center gap-4">
								<div role="button" @click="swiperPrevSlide">
									<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect width="40" height="40" rx="20" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 40)" class="prevarrow" fill="#75AE3D" />
										<path fill-rule="evenodd" clip-rule="evenodd" d="M22.9828 13.6884C23.4501 14.1618 23.4501 14.9292 22.9828 15.4026L18.4443 20L22.9828 24.5975C23.4501 25.0709 23.4501 25.8383 22.9828 26.3117C22.5155 26.785 21.7579 26.785 21.2906 26.3117L15.9059 20.8571C15.4387 20.3838 15.4387 19.6163 15.9059 19.1429L21.2906 13.6884C21.7579 13.215 22.5155 13.215 22.9828 13.6884Z" fill="#161616" />
									</svg>
								</div>
								<div role="button" @click="swiperNextSlide">
									<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect width="40" height="40" rx="20" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 40)" class="nextarrow" fill="#75AE3D" />
										<path fill-rule="evenodd" clip-rule="evenodd" d="M17.0172 26.3116C16.5499 25.8382 16.5499 25.0708 17.0172 24.5974L21.5557 20L17.0172 15.4025C16.5499 14.9291 16.5499 14.1617 17.0172 13.6883C17.4845 13.215 18.2421 13.215 18.7094 13.6883L24.0941 19.1429C24.5614 19.6162 24.5614 20.3837 24.0941 20.8571L18.7094 26.3116C18.2421 26.785 17.4845 26.785 17.0172 26.3116Z" fill="#161616" />
									</svg>
								</div>
							</div>
						</div>
					</div>
					<div class="scardholder ">
						<Swiper :centeredSlides="false" xnitialSlide="1" :pagination="{  el: '.swiper-custom-pagination-sheader', clickable: true, type: 'bullets' }" :loop="false" :grabCursor="true" :slidesPerView="'auto'" :xautoplay="{ delay: 3000 }" :modules="modules" @swiper="onSwiper" class="w-100">
							<SwiperSlide>
								<div class="d-flex justify-content-center cardbody">
									<div class="mcard d-md-flex">
										<div>Gaming</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Tech Art &amp; 3D Modeling</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Web &amp; Software Development</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Big Data &amp; Analytics</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>AI &amp; Data Science</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Cloud Infrastructure &amp; DevOps</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
											</svg>
										</div>
									</div>
								</div>
							</SwiperSlide>
							<SwiperSlide>
								<div class="d-flex justify-content-center cardbody">
									<div class="mcard d-md-flex">
										<div>Telecommunication</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Airspace Engineering</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Bioengineering</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Digital Marketing</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Information Technology</div>
										<div>
											<svg width="33" height="21" viewBox="0 0 33 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect x="0.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24.5" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="0.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12.5" y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
												<rect x="24.5" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
											</svg>
										</div>
									</div>
									<div class="mcard d-md-flex">
										<div>Data Analytics</div>
										<div>
											<svg width="32" height="21" viewBox="0 0 32 21" fill="none" xmlns="http://www.w3.org/2000/svg">
												<rect y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="0.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="12" y="12.5" width="8" height="8" rx="4" fill="#F5F5F5" />
												<rect x="24" y="12.5" width="8" height="8" rx="4" fill="#75AE3D" />
											</svg>
										</div>
									</div>
								</div>
							</SwiperSlide>
						</Swiper>
					</div>
					<div class="swiper-custom-pagination-sheader py-2 d-flex justify-content-center" />
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay } from 'swiper/modules';


import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

let modules = [Pagination, Autoplay];

const swiperInstance = ref();

defineProps({
	options: Object
})

const onSwiper = (swiper) => {
	swiperInstance.value = swiper;
	checkArrows();
};

const swiperNextSlide = () => {
	swiperInstance.value.slideNext();
	checkArrows();
};

const swiperPrevSlide = () => {
	swiperInstance.value.slidePrev();
	checkArrows();
};

const checkArrows = () => {
	document.querySelector(".prevarrow").classList.remove("disabled");
	document.querySelector(".nextarrow").classList.remove("disabled");
	if (swiperInstance.value.activeIndex === 0) {
		document.querySelector(".prevarrow").classList.add("disabled");
	} else if (swiperInstance.value.activeIndex === swiperInstance.value.slides.length - 1) {
		document.querySelector(".nextarrow").classList.add("disabled");
	}
}
</script>
<style lang="scss">
.smainheadern .swiper-custom-pagination-sheader .swiper-pagination-bullet {
	border-radius: 0px;
	width: 60px;
	height: 8px;
}
</style>
<style scoped lang="scss">
.smainheadern .swiper-custom-pagination-sheader {
	--swiper-pagination-color: var(--Green-100, #75AE3D);
	--swiper-pagination-bullet-inactive-color: var(--Off-black-20, #D0D0D0);
	--swiper-pagination-bullet-inactive-opacity: 1;
	--swiper-pagination-bullet-size: 16px;
	--swiper-pagination-bullet-horizontal-gap: 6px;
	--swiper-pagination-bottom: 0px;
}

.cardbody {
	display: flex;
	gap: 20px;
	align-self: stretch;
	flex-wrap: wrap;
}

.mcard {
	position: relative;
	padding: 20px;
	justify-content: space-between;
	align-items: center;
	width: calc(50% - 10px);
	box-sizing: border-box;
	/*flex: 1;*/
	border-radius: 12px;
	background: var(--Off-black-100, #161616);
	color: var(--Off-white, #F5F5F5);
	font-family: Roboto;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
	@media (max-width: 576px) {
		min-height: 150px;
	}
	@media (max-width: 992px) {
		min-height: 90px;
	}
}

.mcard > div {
	word-break: break-all;
}

@media (max-width: 992px) {
	.mcard div {
		padding: 0 20px;
	}
}

@media (max-width: 576px) {
	.mcard div {
		padding: 0;
	}

	.mcard  div + div > svg {
		position: absolute;
		bottom: 10px;
	}

	.mcard  div + div {
		min-height: 33px;
	}
}

.prevarrow.disabled,
.nextarrow.disabled,
	{
	fill: var(--Off-black-20, #D0D0D0);
}

.smainheadern {
	display: flex;
	padding: 40px 0px;
	align-items: flex-start;
	gap: 20px;
}

.stextarea {
	align-items: center;
	gap: 20px;
}

.shtextholder {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 12px;
	align-self: stretch;
	align-self: stretch;
}

.shtext {
	color: var(--Off-black-100, #161616);
	font-family: Roboto;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
	letter-spacing: 0.1px;
	width: 545px;
	@media (max-width: 992px) {
		width: 100%;
	}
}

.hscontent {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
	flex: 1 0 0;
	align-self: stretch;
}

.stitle {
	color: var(--Off-black-100, #161616);
	font-family: Play;
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: normal;
	letter-spacing: 0.1px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.scardholder {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 20px;
	align-self: stretch;
}

.swiper-container {
	width: 100%;
}


.swiper-slide {
	width: 100%;
}

.sh1hsl {
	color: #fff;
}

.sh1hsl:hover {
	color: var(--tt-1);
}

.signbutton:hover rect {
	fill: #fff;
}

.s1h {}

.sheadertext {}

.sheaderbutton {
	margin: 32px 0;
}
</style>